import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ComponentEntity} from "../../../entities/component-entity";
import {getAlignmentText} from "../../../commons/compontents-utils";
import {CommonsUI} from "../../../commons/constans";
import {PositionDirective} from "../../../directives/position.directive";
import {ClickComponentDirective} from "../../../directives/click-component.directive";
import {textComponent} from "../../../commons/defaults-components";


@Component({
  selector: 'lib-text',
  standalone: true,
  imports: [CommonModule, PositionDirective, ClickComponentDirective],
  templateUrl: './text.component.html',
  styleUrl: './text.component.css'
})
export class TextComponent {
  component = input<ComponentEntity>(textComponent());

  protected readonly CommonsUI = CommonsUI;
  protected readonly getAlignmentText = getAlignmentText
}
